import { h } from "@stencil/core";
import { Answers } from "../../api/publicApi/proactive-case-closure";

interface QuestionCommentProps {
    label: string;
    name: string;
    answers: Answers;
    setAnswers: (answers: Answers) => void;
    placeholder: string;
}

/**
 * functional stencil component for a question with a comment field
 */
export function QuestionComment({ label, name, answers, setAnswers, placeholder }: QuestionCommentProps) {
    return (
        <div>
            <div class="mf-proactive-case-closure__question ux-u-margin-top-40 ux-u-margin-bottom-20">{label}</div>
            <div>
                <ux-textarea-field
                    name={name}
                    placeholder={placeholder}
                    onUxTextareaFieldChange={(e: CustomEvent<{ name: string; value: string; textareaFieldId: string }>) =>
                        setAnswers({
                            ...answers,
                            [name]: e.detail.value
                        })
                    }
                ></ux-textarea-field>
            </div>
        </div>
    );
}
